export const addSearchParamsToURL = (
  url: string,
  params: Record<string, string | number | undefined>
): string => {
  const [base, existingQuery = ""] = url.split("?");
  const searchParams = new URLSearchParams(existingQuery);

  Object.keys(params).forEach((paramName) => {
    const paramValue = params[paramName];
    if (paramValue === undefined) {
      return;
    }

    if (searchParams.has(paramName)) {
      searchParams.set(paramName, String(paramValue));
    } else {
      searchParams.append(paramName, String(paramValue));
    }
  });

  const paramString = searchParams.toString();
  return paramString ? `${base}?${paramString}` : base;
};
